import { Package } from "features/packages/Package";
import { cityline } from "features/cityline";

export class AppsStore {
    private constructor() {}
    private static _instance = new AppsStore();
    static get instance() { return AppsStore._instance };

    public ressources = {
        "apple-app-store-badge": require("image/app-store-badge.svg"),
        "google-play-badge": require("image/google-play-badge.svg")
    }

    private images = {
        "bookmarklet-logo": require("!!raw-loader!image/bookmarklet-logo.svg"),
        "chrome-logo": require("!!raw-loader!image/chrome-logo.svg"),
        "firefox-logo": require("!!raw-loader!image/Firefox-logo.svg"),
        "download-logo": require("!!raw-loader!image/download-logo.svg"),
        "upload-logo": require("!!raw-loader!image/upload-logo.svg"),
        "ios-logo": require("!!raw-loader!image/ios-logo.svg"),
        "android-logo": require("!!raw-loader!image/android-logo.svg"),
    };

    private _packages: Package[] = [
        {
            slug: "ios",
            description: "Manage and add links via iPhone or iPad",
            name: "Linkstacks for iOS",
            logo: "ios-logo"
        },
        {
            slug: "android",
            description: "Manage and add links via Android devices",
            name: "Linkstacks for Android",
            logo: "android-logo"
        }
    ];

    public logo(key: string){
        return this.images[key];
    }

    


    async all() : Promise<Package[]> {
        const packages = await cityline.getFrame<Package[]>("packages");
        return this._packages.concat(packages);
    }
}